var map = {
	"./background-magazine.jpg": 31,
	"./background-wine.png": 32,
	"./bg-papier.jpg": 33,
	"./flags/be.svg": 34,
	"./flags/cn.svg": 35,
	"./flags/de.svg": 36,
	"./flags/es.svg": 37,
	"./flags/fr.svg": 38,
	"./flags/gb.svg": 39,
	"./flags/it.svg": 40,
	"./flags/jp.svg": 41,
	"./flags/us.svg": 42,
	"./icons/arrow-article.svg": 43,
	"./icons/back.svg": 44,
	"./icons/close.svg": 45,
	"./icons/error.svg": 46,
	"./icons/facebook.svg": 47,
	"./icons/info.svg": 48,
	"./icons/instagram.svg": 49,
	"./icons/linkedin.svg": 50,
	"./icons/marker.svg": 51,
	"./icons/pinterest.svg": 52,
	"./icons/slider-arrow.svg": 53,
	"./icons/success.svg": 54,
	"./icons/twitter.svg": 55,
	"./icons/weibo.svg": 56,
	"./icons/youtube.svg": 57,
	"./logo.png": 58,
	"./logo.svg": 59,
	"./marker.svg": 60,
	"./menu-bg.png": 61,
	"./pattern.png": 62,
	"./wine-shadow.png": 63
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;